/**
 * @generated SignedSource<<52068f81fc102b7efbf3083d51c0908c>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CreateVerificationRequestInput = {
  clientMutationId?: string | null | undefined;
  verificationRequest: VerificationRequestInput;
};
export type VerificationRequestInput = {
  toUserId: any;
};
export type useVerificationRequestMutation$variables = {
  input: CreateVerificationRequestInput;
};
export type useVerificationRequestMutation$data = {
  readonly createVerificationRequest: {
    readonly clientMutationId: string | null | undefined;
    readonly verificationRequest: {
      readonly toUser: {
        readonly profile: {
          readonly verificationRequested: boolean | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type useVerificationRequestMutation = {
  response: useVerificationRequestMutation$data;
  variables: useVerificationRequestMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clientMutationId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "verificationRequested",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useVerificationRequestMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "CreateVerificationRequestPayload",
        "kind": "LinkedField",
        "name": "createVerificationRequest",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "VerificationRequest",
            "kind": "LinkedField",
            "name": "verificationRequest",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "toUser",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Profile",
                    "kind": "LinkedField",
                    "name": "profile",
                    "plural": false,
                    "selections": [
                      (v3/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useVerificationRequestMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "CreateVerificationRequestPayload",
        "kind": "LinkedField",
        "name": "createVerificationRequest",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "VerificationRequest",
            "kind": "LinkedField",
            "name": "verificationRequest",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "toUser",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Profile",
                    "kind": "LinkedField",
                    "name": "profile",
                    "plural": false,
                    "selections": [
                      (v3/*:: as any*/),
                      (v4/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v4/*:: as any*/)
                ],
                "storageKey": null
              },
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "efd9da35fab53363d24c55c8a4a7e8cc",
    "id": null,
    "metadata": {},
    "name": "useVerificationRequestMutation",
    "operationKind": "mutation",
    "text": "mutation useVerificationRequestMutation(\n  $input: CreateVerificationRequestInput!\n) {\n  createVerificationRequest(input: $input) {\n    clientMutationId\n    verificationRequest {\n      toUser {\n        profile {\n          verificationRequested\n          id\n        }\n        id\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b602315f9e892b950116fc8b818fc282";

export default node;
